// 操作日志管理
import {contractApi} from "@/axios";
//获取操作日志信息
export function getLogPage(params,sendData){
    return contractApi({
        url:'/operateLog/page',
        method:'post',
        data:sendData,
        params:params
    })
}